export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Высота изделия по спинке`, `57`, `58`, `60`, `61`, `62`],
  [`Ширина изделия под проймой`, `37`, `39`, `42`, `44`, `46`]
];
